import { parseCookies } from '@cian/utils';
import { setCookie } from '@cian/utils/lib/browser/cookie';
import * as React from 'react';
import { connect } from 'react-redux';

import { Button } from '../../components/Button';
import { TTypedThunkDispatch } from '../../types/thunk';
import { updateFavorite, IUpdateFavoriteParams, IUpdateFavoriteResolve } from '../../actions/favorites';
import { noop } from '@cian/newbuilding-utils';
import { MountPopup } from '../../components/PopupViewer';
import { ClickOutside } from '../../components/outside';
import { IApplicationState } from '../../types/redux';

import { MotivationPopup } from './MotivationPopup';
import { trackingActionAddFromListingJG, trackingActionRemoveFromListingJK } from '../../actions/analytics';

const ONE_DAY_IN_SECONDS = 24 * 60 * 60;
const TRUTHY_COOKIE_CONTENT = '1';
const MOTIVATION_COOKIE_NAME = 'newbuilding-search-favorite_motivation';

interface IFavoriteButtonOwnProps {
  isFavorite: boolean;
  newbuildingId: number;
  gaLabelFull: string;
}

interface IFavoriteButtonStateProps {
  userIsAuthenticated: boolean;
}

interface IFavoriteButtonDispatchProps {
  setFavorite(params: IUpdateFavoriteParams): Promise<IUpdateFavoriteResolve>;
  trackingAddFromListingJG(gaLabelFull: string): void;
  trackingRemoveFromListingJK(gaLabelFull: string): void;
}

type TFavoriteButtonProps = IFavoriteButtonOwnProps & IFavoriteButtonDispatchProps & IFavoriteButtonStateProps;

export class FavoriteButtonComponent extends React.PureComponent<TFavoriteButtonProps> {
  public state = {
    status: this.props.isFavorite,
    showPopup: false,
  };

  public render() {
    const {
      status,
      showPopup,
    } = this.state;

    return (
      <MountPopup
        placement="left"
        component={
          showPopup &&
          <ClickOutside onOutside={this.closeMotivationPopup}>
            <MotivationPopup onClose={this.closeMotivationPopup}/>
          </ClickOutside>
        }
      >
        <Button
          icon={status ? 'heartFull' : 'heart'}
          iconColor="pink"
          iconColorHovered="pink"
          type="secondary"
          onClick={this.handlerClick}
          dataMark="FavoriteButton"
        >
          {status ? 'В избранном' : 'В избранное'}
        </Button>
      </MountPopup>
    );
  }

  private handlerClick = () => {
    const {
      setFavorite,
      newbuildingId,
      gaLabelFull,
    } = this.props;

    const {
      status,
    } = this.state;
    const newStatus = !status;
    setFavorite({
      status: newStatus,
      newbuildingId,
    }).then(({ status }) => {
      this.setState({ status });
      this.showMotivationPopup();
      if (status) {
        this.props.trackingAddFromListingJG(gaLabelFull);
      } else {
        this.props.trackingRemoveFromListingJK(gaLabelFull);
      }
    }).catch(noop);
  }

  private closeMotivationPopup = () => {
    if (this.state.showPopup) {
      this.setState({ showPopup: false });
    }
  }

  private showMotivationPopup = () => {
    if (this.canSowMotivationPopup()) {
      this.setState({ showPopup: true });
      setCookie(MOTIVATION_COOKIE_NAME, TRUTHY_COOKIE_CONTENT, {
        expires: ONE_DAY_IN_SECONDS,
        secure: false,
      });
    }
  }

  private canSowMotivationPopup = () => {
    const {
      userIsAuthenticated,
    } = this.props;
    const {
      __header_favorites_count__,
    } = window;

    const cookies = parseCookies(document.cookie);

    return !cookies[MOTIVATION_COOKIE_NAME] && !userIsAuthenticated && __header_favorites_count__ === 1;
  }
}

function mapStateToProps(state: IApplicationState) {
  return {
    userIsAuthenticated: state.user.isAuthenticated,
  };
}

function mapDispatchToProps(dispatch: TTypedThunkDispatch): IFavoriteButtonDispatchProps {
  return {
    setFavorite: (params: IUpdateFavoriteParams) => dispatch(updateFavorite(params)),
    trackingAddFromListingJG(gaLabelFull: string) {
      dispatch(trackingActionAddFromListingJG(gaLabelFull));
    },
    trackingRemoveFromListingJK(gaLabelFull: string) {
      dispatch(trackingActionRemoveFromListingJK(gaLabelFull));
    },
  };
}

export const FavoriteButton = connect<
  IFavoriteButtonStateProps,
  IFavoriteButtonDispatchProps,
  IFavoriteButtonOwnProps
>(mapStateToProps, mapDispatchToProps)(FavoriteButtonComponent);
